export default __webpack_public_path__ + "static/media/weapons03.c57f3b76.png";